import keycode from 'keycode';


export const keycodeFromEvent = (event) => {
  const key = keycode(event);
  const code = keycode.codes[key];
  return { key, code, kc: keycode };
}



// WEBPACK FOOTER //
// ./src/shared/helpers/keycode.js